'use client';
import { usePathname } from 'next/navigation';
import IncomingAttribution from './incoming-attribution';
import TelemetryProvider from './telemetry-provider';
import ConsentFirstVisitPrompt from './consent-first-visit-prompt';
export default function SiteTelemetry(){
 const path=usePathname();
 // OAuth state and signed consent belong only to the authorization flow.
 if(path?.startsWith('/oauth/'))return null;
 return <><IncomingAttribution/><TelemetryProvider/><ConsentFirstVisitPrompt/></>;
}
